import { useParams, Link } from "react-router-dom";
import { translations } from "../translations"; // Assurez-vous que le chemin vers translations.js est correct

const Unauthorized = () => {
  const { lang } = useParams(); // Récupérer la langue depuis l'URL (ex: fr ou en)
  
  // Utiliser la traduction en fonction de la langue
  const t = translations[lang] || translations.fr; // Par défaut, utiliser la traduction en français

  return (
    <div className="flex flex-col items-center justify-center min-h-screen text-center">
      <div className="bg-light p-8 rounded-2xl shadow-lg max-w-md">
        <h2 className="text-3xl font-bold text-primary mb-4">{t.page404Message}</h2>
        <p className="text-gray-700 mb-6">
          {t.page404Message}
        </p>
        <Link
          to="/"
          className="px-6 py-3 bg-accent text-white rounded-lg hover:bg-deepblue transition duration-300"
        >
          {t.goBackHome}
        </Link>
      </div>
    </div>
  );
};

export default Unauthorized;

